export default __webpack_public_path__ + "static/media/eth-white.1eee5937.svg";